export default __webpack_public_path__ + "static/media/Aula1.14069170.jpeg";